<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        fill="none"
        stroke="inherit"
        stroke-linecap="round"
        stroke-width="1.2"
        d="m16 10-5 4m-2-2 2 2"
      />
    </svg>
  </span>
</template>
